import React, { useContext } from "react";
import { Context } from "../../../Context";
import { SignatureReceivePanelView } from "../../views";
import { SimpleLoading } from "../../pures";
import {
  SignatureReceiveService,
  SignatureRequestService,
  LocalStorageService,
  PlanService,
  SignatureTypesService,
  UserDocSuppService,
  SignerService,
  UserDocService
} from "../../../services";
import { SignatureRequestValidator } from "../../../validators";
import { process as processKendo } from "@progress/kendo-data-query";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/es";
import { convertDateNoTime, convertToStandarDate, getStampTimeAndTimezone } from "../../../utils";

class SignatureReceivePanelAction extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    skip: 0,
    take: 6,
    group: "",
    sort: [],
    total: 0,
    requests: [],
    newRequests: [],
    originalRequestsReceived: [],
    signatureRequests: [],
    showPagination: { info: false },
    tabSelected: {
      buttonFilterSelectedBlue: "table-button-blue-active",
      buttonFilterSelectedGreen: "",
    },
    signatureRequestInEdit: undefined,
    idCounter: 0,
    visible: false,
    filter: [],
    signatureRequestSelected: {},
    dataItem: {},
    newItem: {},
    name: "",
    description: "",
    id: "",
    userType: {},
    userMiFirmaId: "",
    contractPlanExist: true,
    planName: "",
    signsAvailable: "",
    totalSigns: "",
    expirationDate: "",
    createdDate: "",
    monthlyTransactions: "",
    pricing: "",
    signRequestIdDelete: "",
    signRequestNameDelete: "",
    commentsDelete: "",
    signRequestHasAlmostASign: null,
    buttonFilterSelectedBlue: "",
    buttonFilterSelectedGreen: "",

    visibleDialogDeleteRequest: false,
    errorCommentsDelete: false,
    showLoadingRequesting: false,
    showCompletedRequesting: false,
    showErrorRequesting: false,
    signatureTypes: {},
    initialLoading: true,
    signRequestsStatusId: 2, // Estatus: 1 - Aprobado, 2 - Pendiente, 3 - Rechazado, 4 - Firmado
    signRequestListId: 1, // Lista de servcios: 1 - /signers 2 - /sign-request
    showSelectColumn: false,
    message: "",
    stateSortStart: 0,
    stateSortLimit: 0,
    showSent: false,
    filterOptions: [],
    volumeSigns: [],
    showVolumeSign: false,
    nip: "",
    verifiedNip: false,
    signImage: "",
    canSignByVolume: false,
    messageComplete: "",
    disabledVolumeSign: false,
    isInReceived: true,
    haveSignatures: false
  };

  url = process.env.REACT_APP_MIFIRMA_API;
  signatureReceiveService = new SignatureReceiveService(this.url);
  signatureRequestService = new SignatureRequestService(this.url);
  planService = new PlanService(this.url);
  signatureTypesService = new SignatureTypesService(this.url);
  localStorageService = new LocalStorageService();
  userDocSuppService = new UserDocSuppService(this.url)
  userDocService = new UserDocService(this.url)
  signerService = new SignerService(this.url)
  validator = SignatureRequestValidator(this.props.t);
  timezone = this.localStorageService.getLocalStorageItem("timezone");
  language = this.localStorageService.getLocalStorageItem("preferredLanguage")

  yPositionCanvas = {
    y1: 205,
    y2: 235,
    y3: 275
  }

  async componentDidMount() {
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    let userType = this.user.userMetaData.userMifirma.userType;
    let userMiFirmaId = this.user.userMetaData.userMifirma.id;
    moment.locale("es");

    try {
      let userContractPlan = await this.planService.getUserContractAndPlan(
        this.token
      );

      let signatureTypes = {}
      // let signatureTypes = await this.signatureTypesService.getSignatureTypes(
      //   this.token
      // );

      let newRequests = await this.signatureReceiveService.getAllInbox({
        requestStatus: this.status,
        timezone: this.timezone,
        token: this.token,
        inboxInvolvedType: process.env.REACT_APP_INBOX_INVOLVED_RECEIVED,
      });

      let actionsByRole = await this.signatureReceiveService.getActionsByRole(this.token)

      if (actionsByRole.data.radioSetOptions.length > 1) {
        this.setState({ showSent: true })
      }
      let newRequestsInbox = []

      let { inboxFiltered } = newRequests.data
      if (inboxFiltered && inboxFiltered.length > 0) {
        inboxFiltered.map((request) => {
          // let fullDateStart = new Date(request.inbox.solicitudeStartDate);
          // let dateStart = fullDateStart.getDate();
          // let monthStart = fullDateStart.getMonth() + 1;
          // let yearStart = fullDateStart.getFullYear();
          let dateStartParse = convertToStandarDate(request.inbox.solicitudeStartDate, this.language);
          request.inbox.solicitudeStartDate = dateStartParse || '';
          let dateLimitToParse = convertToStandarDate(request.inbox.solicitudeLimitDate, this.language)
          request.inbox.solicitudeLimitDate = dateLimitToParse;

          request.inbox.email = request.email
          request.inbox.inboxType = this.props.t(`inbox.description.name.${request.inbox.inboxType}`)
          if (request.inbox.inboxTypeTooltip) request.inbox.inboxTypeTooltip = this.props.t(`inbox.description.name.${request.inbox.inboxTypeTooltip}`)

          if (request.inbox.actionName) request.inbox.actionName = this.props.t(`signatureReceivePanelView2.${request.inbox.actionName}`)

          //hide btn trash if user is 'Solicitante'
          let memberType = request.workflowExecutionMemberType ? request.workflowExecutionMemberType.name : null
          let hideTrashBtn = (memberType !== process.env.REACT_APP_MEMBER_TYPE_NAME_SOLICITANTE) ? true : false
          request.inbox.hideTrash = hideTrashBtn
          newRequestsInbox.push(request.inbox)
        });
      } else {
        newRequestsInbox = [];
      }

      /** @type {Array} */
      let volumeSigns = newRequests.data.signaturesByVolumeFinal
      let canSignByVolume = false
      let haveSignatures = false
      if ((volumeSigns && Array.isArray(volumeSigns) && volumeSigns.length > 0)) {
        haveSignatures = true
        canSignByVolume = true
      } else if ((volumeSigns && Array.isArray(volumeSigns) && volumeSigns.length === 0)) {
        canSignByVolume = false
      }

      if (volumeSigns && volumeSigns.length > 0) {
        volumeSigns = volumeSigns.map((request) => {
          let dateLimitToParse = convertToStandarDate(request.limitDate, this.language)
          request.limitDate = dateLimitToParse;

          request.subText = this.props.t("signatureReceivePanelView.subText")
          return request
        });
      } else {
        volumeSigns = [];
      }

      if (!userContractPlan.data) {
        return this.setState({
          signatureTypes: signatureTypes ? signatureTypes : {},
          userType: userType ? userType : {},
          contractPlanExist: false,
          initialLoading: false,
          loading: false,
        });
      } else {
        let { contract, plan } = userContractPlan.data;
        let dateExpiration = contract.endOfContract.split("T")[0];
        const disabledVolumeSign = this.user.userMetaData.userMifirma.usingVolumeSign

        return this.setState({
          filterOptions: actionsByRole.data.comboBoxOptions,
          newRequests: newRequestsInbox,
          originalRequests: newRequestsInbox,
          signatureTypes: signatureTypes ? signatureTypes : {},
          userType: userType ? userType : {},
          userMiFirmaId: userMiFirmaId ? userMiFirmaId : "",
          initialLoading: false,
          contractPlanExist: true,
          planName: plan.name,
          signsAvailable: contract.availableTransaction,
          totalSigns: contract.annualTransaction,
          expirationDate: moment(dateExpiration)
            .format("DD/MMM/YYYY")
            .replace(/\./g, ""),
          createdDate: moment(dateExpiration)
            .format("DD/MMM/YYYY")
            .replace(/\./g, ""),
          monthlyTransactions: contract.monthlyTransaction,
          pricing: contract.pricing,
          buttonFilterSelectedBlue: "table-button-blue-active",
          buttonFilterSelectedGreen: "",
          volumeSigns,
          signImage: newRequests.data.autographySignImg,
          canSignByVolume,
          disabledVolumeSign,
          haveSignatures
        });
      }
    } catch (error) {
      this.props.setShowError(true);
      this.setState({
        initialLoading: false,
      });
    }
  }

  changeStateFilter = (sortStart, sortLimit) => {
    let startState = sortStart;
    let limitState = sortLimit;

    if (startState >= 0 && limitState === undefined) {
      startState += 1;
      if (startState < 3) {
        this.setState({
          stateSortStart: startState,
        });
      } else if (startState === 3) {
        startState = 0;
        this.setState({
          stateSortStart: startState,
        });
      }
    } else if (limitState >= 0 && startState === undefined) {
      limitState += 1;
      if (limitState < 3) {
        this.setState({
          stateSortLimit: limitState,
        });
      } else if (limitState === 3) {
        limitState = 0;
        this.setState({
          stateSortLimit: limitState,
        });
      }
    }
    this.filterByState(startState, limitState);
  };

  filterByState = (sortStart, sortLimit) => {
    let requests = [...this.state.newRequests];

    if ((sortStart && sortLimit <= 0) || sortLimit === undefined) {
      if (sortStart === 1) {
        requests.sort((a, b) =>
          a.solicitudeStartDate < b.solicitudeStartDate
            ? 1
            : a.solicitudeStartDate > b.solicitudeStartDate
              ? -1
              : 0
        );
        this.setState({
          stateSortLimit: 0,
          newRequests: requests,
        });
      } else if (sortStart === 2) {
        requests.sort((a, b) =>
          b.solicitudeStartDate < a.solicitudeStartDate
            ? 1
            : b.solicitudeStartDate > a.solicitudeStartDate
              ? -1
              : 0
        );
        this.setState({
          stateSortLimit: 0,
          newRequests: requests,
        });
      } else {
        if (this.state.signRequestListId === 1) {
          this.setState({
            newRequests: this.state.originalRequests,
          });
        } else {
          this.setState({
            newRequests: this.state.originalRequests,
          });
        }
      }
    } else if ((sortLimit && sortStart <= 0) || sortStart === undefined) {
      if (sortLimit === 1) {
        requests.sort((a, b) =>
          a.solicitudeLimitDate < b.solicitudeLimitDate
            ? 1
            : a.solicitudeLimitDate > b.solicitudeLimitDate
              ? -1
              : 0
        );
        this.setState({
          stateSortStart: 0,
          newRequests: requests,
        });
      } else if (sortLimit === 2) {
        requests.sort((a, b) =>
          b.solicitudeLimitDate < a.solicitudeLimitDate
            ? 1
            : b.solicitudeLimitDate > a.solicitudeLimitDate
              ? -1
              : 0
        );
        this.setState({
          stateSortStart: 0,
          newRequests: requests,
        });
      } else {
        this.setState({
          newRequests: this.state.originalRequests,
        });
      }
    }
  };

  /**
   * @author Alan Aguilar
   * @date 14-04-2021
   * @description Filter an array of signRequest and filter by dataState props
   * @param {Object} dataState
   * @memberof SignatureReceivePanelAction
   */
  processNewState = (dataState) => {
    let response = processKendo(this.state.requests.slice(0), dataState);
    return {
      signatureRequests: response.data,
      total: response.total,
    };
  };

  /**
   * @author Alan Aguilar
   * @date 14-04-2021
   * @description Change the data information in the table adding sortable props
   * @param {Object} event
   * @memberof SignatureReceivePanelAction
   */
  dataStateChange = (event) => {
    let { signatureRequests, total } = this.processNewState(event.dataState);
    this.setState(
      {
        signatureRequests,
        total,
        filter: event.dataState.filter ? event.dataState.filter : undefined,
        group: event.dataState.group ? event.dataState.group : undefined,
        sort: event.dataState.sort ? event.dataState.sort : [],
        skip: event.dataState.skip,
        take: event.dataState.take,
      },
      () => {
        this.onChangeFooterInfoPagination(
          this.state.requests,
          this.state.take,
          this.state.skip
        );
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @date 19-11-2020
   * @description Change the rendering of a custom footer in the grid
   * @param {Array} elements
   * @param {Number} take
   * @param {Number} skip
   * @memberof SignatureReceivePanelAction
   */
  onChangeFooterInfoPagination = (elements, take, skip) => {
    let showPagination = false;
    let paginationInfoExist = document.querySelector(
      "#infoPaginationSignRequestReceive"
    );

    if (paginationInfoExist) {
      paginationInfoExist.remove();
      showPagination = false;
    }

    let totalItemsInTable = elements.length;

    if (elements.length !== 0) {
      showPagination = { info: false };
      let currentPage = Math.floor(skip / take) + 1;
      let totalPages = Math.ceil((totalItemsInTable || 0) / take);

      let firstItemInPage = skip + 1;
      let lastItemInPage = 0;
      if (currentPage === totalPages) {
        lastItemInPage = totalItemsInTable;
      } else {
        lastItemInPage = skip + take;
      }

      let footerPagination = document.querySelector("div[role='navigation']");
      if (footerPagination) {
        let element = document.createElement("div");
        element.id = "infoPaginationSignRequestReceive";
        element.innerHTML = `<span style="font-family: Quicksand, sans-serif">${firstItemInPage} - ${lastItemInPage} de ${totalItemsInTable} Solicitudes</span> <span style="margin-left: 30px; font-family: Quicksand, sans-serif;">${currentPage}/${totalPages}</span>`;
        element.className = "k-pager-info k-label";
        footerPagination.appendChild(element);
      }
    } else {
      showPagination = false;
    }

    return showPagination;
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to show and close the Dialog Delete
   * @param {Object} dataItem
   * @memberof SignatureReceivePanelAction
   */
  toggleDialogDeleteRequest = (signRequest) => {

    this.newItem =
      signRequest?.solicitudeId != undefined
        ? signRequest
        : this.newItem;
    this.setState({
      visibleDialogDeleteRequest: !this.state.visibleDialogDeleteRequest,
      signRequestIdDelete: this.newItem.solicitudeId,
      signRequestNameDelete: this.newItem.solicitudeName,
      signRequestHasAlmostASign: this.newItem.signRequestHasAlmostASign,
    });
    if (this.state.visibleDialogDeleteRequest === false)
      this.setState({ errorCommentsDelete: false });
  };

  /**
   * @author Adrian Montemayor
   * @description Save User data when redirecting to register onboarding
   * @memberof SignatureReceivePanelAction
   */
  onInvitedExistRedirectRegister = async () => {
    this.user = this.localStorageService.getLocalStorageItem("user");
    let userInformation = this.user.userMetaData.userA3Cloud;
    let address = userInformation.address;

    let phone = userInformation.phoneNumber ? userInformation.phoneNumber : "0";
    let externalNumberValue = address.externalNumber
      ? address.externalNumber
      : "";
    let cellPhone = userInformation.cellphoneNumber
      ? userInformation.cellphoneNumber
      : "0";

    let userCapturedInformation = {
      firstName: userInformation.firstName,
      firstLastName: userInformation.firstLastName,
      secondLastName: userInformation.secondLastName,
      phoneNumber: phone,
      cellphoneNumber: cellPhone,
      email: userInformation.email,
      rfc: userInformation.rfc,
      personlDataFill: true,
    };

    await this.localStorageService.setLocalStorageItem(
      "userCapturedInformation",
      userCapturedInformation
    );
    this.props.onInvitedRedirectRegister();
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to show and close the Dialog Loading Requesting
   * @param {Object} dataItem
   * @memberof SignatureReceivePanelAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
      visibleDialogDeleteRequest: false,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to show and close the Dialog Complete Request
   * @param {Object} dataItem
   * @memberof SignatureReceivePanelAction
   */
  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Handler method to show and close the Dialog Error Request
   * @memberof SignatureReceivePanelAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 6000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Edit a signer
   * @param {Object} dataItem
   * @memberof SignatureReceivePanelAction
   */
  edit = (dataItem) => {
    this.setState({
      signatureRequestInEdit: this.cloneSignatureRequest(dataItem),
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler method for submit the comments to the state
   * @memberof SignatureReceivePanelAction
   */
  handleCommentsDelete = async (event) => {
    this.setState({
      commentsDelete: event.target.value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler Method to delete a sign request
   * @updatedDate 04-06-2021
   * @memberof SignatureReceivePanelAction
   */
  deleteSignRequest = async () => {
    if (!this.state.commentsDelete) {
      this.setState({
        errorCommentsDelete: true
      })

      return false;
    }

    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    let { signRequestIdDelete, commentsDelete, signRequestsStatusId } =
      this.state;
    let statusCode = 0;


    try {
      await this.toggleLoadingRequesting(true);
      let signRequestDetele =
        await this.signatureRequestService.deleteSignRequestsById(
          signRequestIdDelete,
          commentsDelete,
          this.token
        );
      if (signRequestDetele.statusCode !== 200) {
        statusCode = signRequestDetele.statusCode;
        throw new Error();
      }

      this.setState(
        {
          visibleDialogDeleteRequest: false,
          errorCommentsDelete: false,
          loading: true,
          message: "",
        },
        () => {
          this.onChangeFooterInfoPagination(
            this.state.requests,
            this.state.take,
            this.state.skip
          );
        }
      );
      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true);
    } catch (error) {
      switch (statusCode) {
        case -2:
          this.setState({
            message: this.props.t(
              "signatureReceivePanelView2.errorMessageOnlyUserSenderCanDelete"
            ),
          });
          break;
        case -3:
          this.setState({
            message: this.props.t(
              "signatureReceivePanelView2.errorMessageOnlyDeleteWithAlmostOneSign"
            ),
          });
          break;
        default:
          this.setState({
            message: this.props.t(
              "signatureReceivePanelView2.errorMessageDefault"
            ),
          });
          break;
      }
      this.setState({ visibleDialogDeleteRequest: false });
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }

    const dataInboxRequest = {
      requestStatus: this.status,
      timezone: this.timezone,
      token: this.token,
      inboxInvolvedType: (this.state.signRequestListId === 1) ? process.env.REACT_APP_INBOX_INVOLVED_RECEIVED : process.env.REACT_APP_INBOX_INVOLVED_SENT
    }
    const requests = await this.signatureReceiveService.getAllInbox(dataInboxRequest)

    let newRequestsInbox = []
    let { inboxFiltered } = requests.data
    if (inboxFiltered && inboxFiltered.length > 0) {
      inboxFiltered.map((request) => {
        let dateStartParse = convertToStandarDate(request.inbox.solicitudeStartDate, this.language)
        request.inbox.solicitudeStartDate = dateStartParse || '';
        let dateLimitToParse = convertToStandarDate(request.inbox.solicitudeLimitDate, this.language)
        request.inbox.solicitudeLimitDate = dateLimitToParse;

        request.inbox.email = request.email
        request.inbox.inboxType = this.props.t(`inbox.description.name.${request.inbox.inboxType}`)
        if (request.inbox.inboxTypeTooltip) request.inbox.inboxTypeTooltip = this.props.t(`inbox.description.name.${request.inbox.inboxTypeTooltip}`)

        if (request.inbox.actionName) request.inbox.actionName = this.props.t(`signatureReceivePanelView2.${request.inbox.actionName}`)

        newRequestsInbox.push(request.inbox)
      })
    }

    /** @type {Array} */
    let volumeSigns = requests.data.signaturesByVolumeFinal
    let canSignByVolume = false
    let haveSignatures = false
    if ((volumeSigns && Array.isArray(volumeSigns) && volumeSigns.length > 0)) {
      haveSignatures = true
      canSignByVolume = true
    } else if ((volumeSigns && Array.isArray(volumeSigns) && volumeSigns.length === 0)) {
      canSignByVolume = false
    }

    if (volumeSigns && volumeSigns.length > 0) {
      volumeSigns = volumeSigns.map((request) => {
        let dateLimitToParse = convertToStandarDate(request.limitDate, this.language)
        request.limitDate = dateLimitToParse;

        request.subText = this.props.t("signatureReceivePanelView.subText")
        return request
      });
    } else {
      volumeSigns = [];
    }
    this.setState({
      skip: 0,
      take: 6,
      signRequestIdDelete: "",
      commentsDelete: "",
      newRequests: newRequestsInbox,
      signatureRequests: inboxFiltered.slice(0, 6),
      total: inboxFiltered.length,
      loading: false,
      canSignByVolume,
      haveSignatures
    });
  };

  /**
   * @author Alan Aguilar
   * @description Handler Method of the select for filter sign-request by orderStatusId
   * @date 12-10-2020
   * @param {Object} event
   * @memberof SignatureReceivePanelAction
   */
  onFilterSignRequest = (event) => {
    let statusSelected = Number(event.target.value);

    if (statusSelected !== this.state.signRequestsStatusId) {
      let requests;
      this.setState(
        { signRequestsStatusId: statusSelected, loading: true },
        async () => {
          if (this.state.signRequestListId === 1) {
            requests =
              await this.signatureReceiveService.getSignRequestsByStatus(
                statusSelected,
                this.token
              );
          } else if (this.state.signRequestListId === 2) {
            requests = await this.signatureRequestService.getSignatureRequests(
              statusSelected,
              100,
              this.token
            );
          }

          requests = requests.data.map((request) => {
            let arraySignRequestExpirationDate =
              request.expirationDate.split("/");
            let dateParseExpirationDate =
              arraySignRequestExpirationDate[0] +
              "/" +
              moment(arraySignRequestExpirationDate[1])
                .format("MMM")
                .replace(/\./g, "") +
              "/" +
              arraySignRequestExpirationDate[2];
            request.expirationDate = dateParseExpirationDate;

            let arraySignRequestCreatedDate = request.createdDate.split("/");
            let dateParseCreatedDate =
              arraySignRequestCreatedDate[0] +
              "/" +
              moment(arraySignRequestCreatedDate[1])
                .format("MMM")
                .replace(/\./g, "") +
              "/" +
              arraySignRequestCreatedDate[2];
            request.createdDate = dateParseCreatedDate;
            return request;
          });

          this.setState(
            {
              skip: 0,
              take: 6,
              signatureRequests: requests.slice(0, 6),
              total: requests.length,
              requests,
              loading: false,
            },
            () => {
              this.onChangeFooterInfoPagination(
                requests,
                this.state.take,
                this.state.skip
              );
            }
          );
        }
      );
    } else {
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Handler Method to change the styles of the list of signRequest selected by status filter
   * @date 04-09-2020
   * @param {Number} listSeleted
   * @memberof SignatureReceivePanelAction
   */
  onSelectSignRequestList = async (listSeleted) => {
    if (listSeleted === this.state.signRequestListId) return false;
    let isInReceived

    let canSignByVolume = false
    let haveSignatures = false
    this.setState({
      tabSelected: {
        buttonFilterSelectedBlue:
          listSeleted === 1 ? "table-button-blue-active" : "",
        buttonFilterSelectedGreen:
          listSeleted === 2 ? "table-button-blue-active" : "",
      },
      loading: true,
      buttonFilterSelectedBlue: "",
      buttonFilterSelectedGreen: "",
      isInReceived: false,
    });

    // Clasificar cual servicio se va a llamar y asignar la clase del button a el tab seleccionado
    let nuevasSolicitudes = [];

    if (listSeleted === 1) {
      isInReceived = true
      let requests = await this.signatureReceiveService.getAllInbox(
        process.env.REACT_APP_INBOX_INVOLVED_RECEIVED,
        this.timezone,
        this.token
      );

      let { inboxFiltered } = requests.data

      if (inboxFiltered && inboxFiltered.length > 0) {
        inboxFiltered.map((request) => {
          let dateStartParse = convertToStandarDate(request.inbox.solicitudeStartDate, this.language);
          request.inbox.solicitudeStartDate = dateStartParse || '';
          let dateLimitToParse = convertToStandarDate(request.inbox.solicitudeLimitDate, this.language)
          request.inbox.solicitudeLimitDate = dateLimitToParse;

          request.inbox.email = request.email
          request.inbox.inboxType = this.props.t(`inbox.description.name.${request.inbox.inboxType}`)
          if (request.inbox.inboxTypeTooltip) request.inbox.inboxTypeTooltip = this.props.t(`inbox.description.name.${request.inbox.inboxTypeTooltip}`)

          if (request.inbox.actionName) request.inbox.actionName = this.props.t(`signatureReceivePanelView2.${request.inbox.actionName}`)

          nuevasSolicitudes.push(request.inbox)
        });
      } else {
        nuevasSolicitudes = [];
      }

      /** @type {Array} */
      let volumeSigns = requests.data.signaturesByVolumeFinal
      if ((volumeSigns && Array.isArray(volumeSigns) && volumeSigns.length > 0)) {
        haveSignatures = true
        canSignByVolume = true
      } else if ((volumeSigns && Array.isArray(volumeSigns) && volumeSigns.length === 0)) {
        canSignByVolume = false
      }

      if (volumeSigns && volumeSigns.length > 0) {
        volumeSigns = volumeSigns.map((request) => {
          let dateLimitToParse = convertToStandarDate(request.limitDate, this.language)
          request.limitDate = dateLimitToParse;

          request.subText = this.props.t("signatureReceivePanelView.subText")
          return request
        });
      } else {
        volumeSigns = [];
      }

      this.setState({
        signRequestsStatusId: this.state.signRequestsStatusId,
        buttonFilterSelectedBlue: "table-button-blue-active",
        buttonFilterSelectedGreen: "",
        signRequestListId: 1,
        isInReceived,
        canSignByVolume,
        haveSignatures
      });
    } else if (listSeleted === 2) {
      isInReceived = false
      let requests = await this.signatureReceiveService.getAllInbox(
        process.env.REACT_APP_INBOX_INVOLVED_SENT,
        this.timezone,
        this.token
      );

      let { inboxFiltered } = requests.data

      if (inboxFiltered && inboxFiltered.length > 0) {
        inboxFiltered.map((request) => {
          let dateStartParse = convertToStandarDate(request.inbox.solicitudeStartDate, this.language);
          request.inbox.solicitudeStartDate = dateStartParse || '';
          let dateLimitToParse = convertToStandarDate(request.inbox.solicitudeLimitDate, this.language)
          request.inbox.solicitudeLimitDate = dateLimitToParse;

          request.inbox.email = request.email
          request.inbox.inboxType = this.props.t(`inbox.description.name.${request.inbox.inboxType}`)
          if (request.inbox.inboxTypeTooltip) request.inbox.inboxTypeTooltip = this.props.t(`inbox.description.name.${request.inbox.inboxTypeTooltip}`)

          if (request.inbox.actionName) request.inbox.actionName = this.props.t(`signatureReceivePanelView2.${request.inbox.actionName}`)

          nuevasSolicitudes.push(request.inbox)
        });
      } else {
        nuevasSolicitudes = [];
      }

      /** @type {Array} */
      let volumeSigns = requests.data.signaturesByVolumeFinal
      if ((volumeSigns && Array.isArray(volumeSigns) && volumeSigns.length > 0)) {
        haveSignatures = true
        canSignByVolume = true
      } else if ((volumeSigns && Array.isArray(volumeSigns) && volumeSigns.length === 0)) {
        canSignByVolume = false
      }

      if (volumeSigns && volumeSigns.length > 0) {
        volumeSigns = volumeSigns.map((request) => {
          let dateLimitToParse = convertToStandarDate(request.limitDate, this.language)
          request.limitDate = dateLimitToParse;

          request.subText = this.props.t("signatureReceivePanelView.subText")
          return request
        });
      } else {
        volumeSigns = [];
      }

      this.setState({
        signRequestsStatusId: this.state.signRequestsStatusId,
        buttonFilterSelectedGreen: "table-button-blue-active",
        buttonFilterSelectedBlue: "",
        signRequestListId: 2,
        isInReceived,
        haveSignatures,
        canSignByVolume
      });
    } else {
      return false;
    }
    this.setState({
      newRequests: nuevasSolicitudes,
      originalRequests: nuevasSolicitudes,
      loading: false,
    });
  };

  rowRender = (trElement, dataItem) => {
    return (
      <tr style={{ borderCollapse: "collapse", padding: 0, borderSpacing: 0 }}>
        {trElement.props.children}{" "}
      </tr>
    );
  };

  cloneSignatureRequest(signatureRequest) {
    return Object.assign({}, signatureRequest);
  }

  /**
   * @author Pedro Antonio
   * @param {boolean} isMobile
   * @memberof SignatureReceivePanelAction
   */
  signByVolume = async (isMobile) => {
    try {
      /** @type {string[]} */
      const volumeSignsIds = [...this.state.volumeSigns].map(item => item.id).slice(0, +process.env.REACT_APP_QUANTITY_SIGNATURES)
      const stampTime = await getStampTimeAndTimezone()
      this.setDateInCanvas(stampTime, isMobile)
      const image = this.saveImage()
      this.setState({ verifiedNip: false, showVolumeSign: false, showLoadingRequesting: true })
      const autographySign = await fetch(image)
        .then((res) => res.blob())
        .catch(() => false)

      if (!autographySign) throw new Error("")
      const formData = new FormData()
      formData.append("sign1", autographySign)
      formData.append("solicitudeIds", JSON.stringify(volumeSignsIds))
      formData.append("signatureStampTime", stampTime)
      formData.append("isMobile", isMobile)
      const sendSolicitudeToSignByVolume = await this.signerService.signByVolume(formData, this.token)
      if (sendSolicitudeToSignByVolume.statusCode !== 200) {
        this.setState({
          nip: "",
          showLoadingRequesting: false,
          showErrorRequesting: true,
          message: "Ocurrió un error con la petición. Intenta más tarde."
        }, () => {
          setTimeout(() => {
            this.setState({
              showErrorRequesting: false,
            })
          }, 3000);
        })
      } else {
        this.setState({
          nip: "",
          showLoadingRequesting: false,
          showCompletedRequesting: true,
          messageComplete: "Tus firmas están en proceso. Se te mandará un correo con el reporte de firmas."
        }, () => {
          setTimeout(() => {
            this.setState({
              showCompletedRequesting: false,
            }, () => {
              this.setState({ initialLoading: true }, () => {
                setTimeout(() => {
                  const otherSignatures = [...this.state.newRequests]
                  volumeSignsIds.forEach(signature => {
                    const signatureFound = otherSignatures.findIndex(originalSign => originalSign.solicitudeId === signature)
                    otherSignatures.splice(signatureFound, 1)
                  });
                  this.setState({ initialLoading: false, newRequests: otherSignatures, canSignByVolume: false })
                }, 3000)
              })
            })
          }, 3000);
        })
      }
    } catch (e) {
      this.setState({
        nip: "",
        showLoadingRequesting: false,
        showErrorRequesting: true,
        message: "Ocurrió un error con la petición. Intenta más tarde."
      }, () => {
        this.setState({
          showErrorRequesting: false,
        })
      })
    }
  }

  returnVerifyNip = () => this.setState({ nip: "", verifiedNip: false })


  setDateInCanvas = (firstName, isMobile) => {
    if (isMobile) {
      this.yPositionCanvas = {
        y3: (window.innerWidth / 2.09) - 20
      }
    }
    this.setTextInCanvas(this.yPositionCanvas.y3, `${firstName}`, isMobile)
  }

  saveImage = () => {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let destinationCanvas = document.createElement("canvas");
    destinationCanvas.height = sourceCanvas.height;
    destinationCanvas.width = sourceCanvas.width;
    let destinationContext = destinationCanvas.getContext("2d");
    destinationContext.drawImage(sourceCanvas, 0, 0);
    destinationContext.globalCompositeOperation = "destination-over";
    destinationContext.fillStyle = "#4484a500";
    destinationContext.fillRect(
      0,
      0,
      sourceCanvas.width,
      sourceCanvas.height
    );
    return destinationCanvas.toDataURL("image/png")
  };

  setTextInCanvas = (y, text, isMobile) => {
    try {
      let sourceCanvas = document.getElementsByTagName("canvas")
      const gottenCanvas = sourceCanvas[1]
      let ctx = gottenCanvas.getContext("2d");
      //Corregir a 11px para móvil
      isMobile ? ctx.font = "bold 13px Arial" : ctx.font = "bold 23px Arial"
      ctx.textAlign = "center";
      ctx.fillText(text, !isMobile ? gottenCanvas.width / 2 : (gottenCanvas.width / 2), y, gottenCanvas.width);
    } catch (error) { }
  }


  /**
   * @author Pedro Antonio
   * @date 19/09/2024
   * @param {string} nip
   * @memberof SignatureReceivePanelAction
   */
  setNip = (nip) => this.setState({ nip })

  /**
   * @author Pedro Antonio
   * @date 19/09/2024
   * @param {string} nip
   * @memberof SignatureReceivePanelAction
   */
  showVolumeDialog = (value) => this.setState({ showVolumeSign: value, nip: "" })

  /**
   * @author Pedro Antonio
   * @date 19/09/2024
   * @param {string} nip
   * @memberof SignatureReceivePanelAction
   */
  setVerifiedNip = async () => {
    try {
      this.setState({ showVolumeSign: false })
      this.toggleLoadingRequesting(true)
      let newNip = await this.userDocService.verifyNip(this.state.nip, this.token)
      if (newNip.isEqual === false) {
        this.setState({ showVolumeSign: false, nip: "", message: this.props.t(`signatureRequestDetailAction2.errorNip`), showLoadingRequesting: false, showErrorRequesting: true }, () =>
          setTimeout(() => this.setState({ showErrorRequesting: false, showVolumeSign: true, message: "" }), 3000))
      } else {
        this.toggleLoadingRequesting(false)
        this.setState({ verifiedNip: true, showVolumeSign: true })
        setTimeout(() => {
          this.setImageInCanvas(`data:image/png;base64,${this.state.signImage}`)
        }, 100)
      }
    } catch (e) {

    }
  }

  setImageInCanvas = (img) => {
    const image = new Image()
    image.src = img
    try {
      let sourceCanvas = document.getElementsByTagName("canvas")[1];
      let ctx = sourceCanvas.getContext("2d");
      let height = sourceCanvas.height;
      let width = sourceCanvas.width;
      image.onload = () => {
        ctx.drawImage(
          image,
          0,
          0,
          width,
          height
        )
      }
    } catch (error) {
    }
  }

  render() {
    if (this.state.initialLoading) {
      return (
        <div className="standard-wrapper">
          <SimpleLoading />
        </div>
      );
    } else {
      return (
        <SignatureReceivePanelView
          {...this.state}
          showErrorRequesting={this.state.showErrorRequesting}
          setNip={this.setNip}
          showVolumeDialog={this.showVolumeDialog}
          signByVolume={this.signByVolume}
          setVerifiedNip={this.setVerifiedNip}
          setImageInCanvas={this.setImageInCanvas}
          returnVerifyNip={this.returnVerifyNip}
          edit={this.edit}
          rowRender={this.rowRender}
          cloneSignatureRequest={this.cloneSignatureRequest}
          newProduct={this.newProduct}
          sentRequests={this.sentRequests}
          receivedRequests={this.receivedRequests}
          onSelectSignRequestList={this.onSelectSignRequestList}
          onFilterSignRequest={this.onFilterSignRequest}
          deleteSignRequest={this.deleteSignRequest}
          toggleDialogDeleteRequest={this.toggleDialogDeleteRequest}
          handleCommentsDelete={this.handleCommentsDelete}
          view={"/"}
          toggleLoadingRequesting={this.toggleLoadingRequesting}
          toggleCompletedRequesting={this.toggleCompletedRequesting}
          toggleErrorRequesting={this.toggleErrorRequesting}
          onInvitedRedirectRegister={this.onInvitedExistRedirectRegister}
          dataStateChange={this.dataStateChange}
          filterByState={this.changeStateFilter}
          stateSortStart={this.state.stateSortStart}
          stateSortLimit={this.state.stateSortLimit}
        />
      );
    }
  }
}

function SignatureReceivePanelActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return (
    <SignatureReceivePanelAction {...props} t={t} setShowError={setShowError} />
  );
}

export { SignatureReceivePanelActionContainer as default };
